import { ILoggedIn } from '@checkout/state';
import * as React from 'react';
import { Fragment } from 'react';
import { SyntheticEvent } from 'react';
import { InjectedIntlProps } from 'react-intl';
import { Button } from '..';
import { CheckoutContextConfig } from '../../../apps/CheckoutApp';
import messages from './../../../i18n/base-en';
import * as Styles from './EmptyBagInfo.scss';

interface IOwnProps extends InjectedIntlProps {
  withLink?: boolean;
  handleMembershipOpen?: (event: SyntheticEvent<HTMLButtonElement>) => void;
  loggedIn?: ILoggedIn | null;
}

const EmptyBagInfo: React.SFC<IOwnProps> = ({ intl, withLink = true, handleMembershipOpen, loggedIn }) => {
  const { formatMessage } = intl;

  return (
    <CheckoutContextConfig.Consumer>
      {(checkoutContextConfig => (
        <div className={Styles.content}>
          <span className={Styles.message}>{formatMessage(messages.empty_bag_info)}</span>
          {withLink && <div className={Styles.bottom}>
            <a className={Styles.link} href="/">
              {formatMessage(messages.empty_bag_button_label)}
            </a>
            <Fragment>
              {handleMembershipOpen && loggedIn === null && checkoutContextConfig.modules.membership.isEnabled && (
                <div>
                  <p>{formatMessage(messages.empty_bag_or)}</p>
                  <Button
                    onClick={handleMembershipOpen}
                    type="button"
                    variant="primary"
                    align="center"
                    size="medium"
                    label={formatMessage(messages.membership_login_button_label)}
                  />
                </div>
              )}
            </Fragment>
          </div>}
        </div>
      ))}
    </CheckoutContextConfig.Consumer>
  );
};

export default EmptyBagInfo;
